function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#de290f",
    d: "M 225.5,-0.5 C 241.5,-0.5 257.5,-0.5 273.5,-0.5C 362.269,10.9489 428.436,55.6156 472,133.5C 486.559,162.333 495.726,192.666 499.5,224.5C 499.5,241.167 499.5,257.833 499.5,274.5C 487.764,361.841 443.764,427.341 367.5,471C 338.093,486.083 307.093,495.583 274.5,499.5C 257.833,499.5 241.167,499.5 224.5,499.5C 132.596,487.072 65.4294,439.739 23,357.5C 10.7506,330.604 2.91724,302.604 -0.5,273.5C -0.5,257.5 -0.5,241.5 -0.5,225.5C 11.4543,135.075 57.4543,68.242 137.5,25C 165.514,11.5012 194.847,3.00119 225.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedc00",
    d: "M 257.5,28.5 C 258.47,33.6903 258.636,39.0236 258,44.5C 263.101,46.9668 268.267,49.3002 273.5,51.5C 267.889,53.0888 262.222,54.4221 256.5,55.5C 256.091,61.5015 255.591,67.5015 255,73.5C 252.365,68.7017 249.532,64.0351 246.5,59.5C 245.667,59.1667 244.833,58.8333 244,58.5C 239.207,59.9112 234.373,60.7445 229.5,61C 233.23,56.9408 236.564,52.6075 239.5,48C 236.42,43.3123 233.92,38.4789 232,33.5C 237.135,36.6624 242.635,38.4957 248.5,39C 251.389,35.3756 254.389,31.8756 257.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedd00",
    d: "M 123.5,50.5 C 124.497,50.4701 125.164,50.9701 125.5,52C 130.533,68.2659 135.866,84.4326 141.5,100.5C 159.157,101.333 176.824,101.833 194.5,102C 180.756,112.289 166.922,122.455 153,132.5C 153.011,136.225 153.677,139.892 155,143.5C 159.989,157.271 164.155,170.938 167.5,184.5C 153.446,173.779 139.113,163.446 124.5,153.5C 110.323,163.422 96.323,173.589 82.5,184C 81.8333,184.667 81.1667,184.667 80.5,184C 85.3242,169.527 90.1575,155.027 95,140.5C 95.995,137.874 96.3283,135.207 96,132.5C 82.0778,122.455 68.2445,112.289 54.5,102C 72.1667,101.667 89.8333,101.333 107.5,101C 113.335,84.3289 118.668,67.4955 123.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedb00",
    d: "M 289.5,78.5 C 293.51,82.3434 297.677,86.0101 302,89.5C 307.105,86.8543 312.272,84.6877 317.5,83C 314.317,87.6983 311.65,92.6983 309.5,98C 312.785,102.288 316.452,106.288 320.5,110C 314.833,109.667 309.167,109.333 303.5,109C 300.623,113.712 297.957,118.545 295.5,123.5C 294.141,117.919 293.308,112.252 293,106.5C 287.239,105.177 281.406,104.011 275.5,103C 280.38,100.643 285.214,98.1427 290,95.5C 290.242,89.8333 290.075,84.1667 289.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedb00",
    d: "M 298.5,150.5 C 300.865,155.241 302.865,160.241 304.5,165.5C 310.138,166.33 315.804,166.83 321.5,167C 317.311,170.69 312.978,174.19 308.5,177.5C 311.244,182.626 313.078,187.959 314,193.5C 309.487,190.244 304.82,187.244 300,184.5C 295.392,187.436 291.059,190.77 287,194.5C 287.211,189.014 288.378,183.681 290.5,178.5C 286.051,174.768 281.384,171.268 276.5,168C 282.196,167.83 287.862,167.33 293.5,166.5C 295.172,161.137 296.839,155.804 298.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fedc00",
    d: "M 256.5,203.5 C 257.473,205.948 257.806,208.615 257.5,211.5C 257.187,214.247 257.52,216.914 258.5,219.5C 263.506,221.502 268.506,223.502 273.5,225.5C 268.172,227.166 262.839,228.832 257.5,230.5C 256.67,236.472 256.17,242.472 256,248.5C 252.958,243.581 249.791,238.748 246.5,234C 240.833,235 235.167,236 229.5,237C 233.23,232.941 236.564,228.608 239.5,224C 236.91,219.075 233.91,214.408 230.5,210C 235.898,211.3 241.232,213.134 246.5,215.5C 250.203,211.798 253.537,207.798 256.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f18e07",
    d: "M 257.5,211.5 C 257.806,208.615 257.473,205.948 256.5,203.5C 256.783,202.711 257.283,202.044 258,201.5C 258.808,205.027 258.641,208.36 257.5,211.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.fe51cc55311620150a6143f4a3030d4f.svg";
export { ForwardRef as ReactComponent };